<template>
  <div>
    <h3>Paramètres > Département </h3>
    <br>

    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true" >
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5" >
      <v-card-title>
        <h6 class="primary--text">Liste des départements</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('export departments')">
          <export-excel
            :data = "departements"
            name = "Departements.xls"
            :export-fields ="departements_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create departments')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
          </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="editedItem.country_id"
                      :items="pays"
                      item-text="name"
                      item-value="id"
                      label="Pays"
                      clearable
                      solo></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.name" label="Nom du département" solo></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" rounded @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" rounded @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher un département"
          single-line
          solo
          hide-details>
        </v-text-field>

      </v-card-title>
    </v-card>
  <v-data-table
    :headers="headers"
    :items="departements"
    :loading="loading"
    loading-text="Loading..."
    sort-by="name"
    :search="search"
    class="elevation-1">
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
        v-if="$can('edit departments')">
        mdi-pencil-outline
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
        v-if="$can('delete departments')">
        mdi-trash-can-outline
      </v-icon>
    </template>
  </v-data-table>

  <v-layout row justify-center>
    <v-dialog
      v-model="dialog_deletion"
      max-width="290">
      <v-card>
        <v-card-title class="headline">Suppression</v-card-title>
        <v-card-text class="text-center">
         Etes-vous sûr de vouloir supprimer ce département ?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="orange"
            rounded
            @click="dialog_deletion = false">
             <span class="white-couleur">Non</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            rounded
            @click="delDepartment()">
            Oui
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-department',
  mixins: [Permissions],
  data: () => ({
    del_department: null,
    del_index: null,
    search: '',
    dialog_edit: false,
    loading: false,
    dialog_deletion: false,
    headers: [
          { text: 'Département', value: 'name' },
          { text: 'Pays', value: 'country.name' },
          { text: 'Actions', value: 'action', sortable: false }
        ],
    departements_fields : {
          "Département": "name",
          "Pays": "country.name",
      },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      country_id: null,
    },
    defaultItem: {
      name: '',
      country_id: null,
    },

  }),

  created () {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    pays () { return this.$store.getters.countries; },
    departements () { return this.$store.getters.departments; },
    formTitle () {
        return this.editedIndex === -1 ? 'Nouveau département' : 'Editer le département'
      },
  },

  watch: {
      dialog (val) {
        val || this.close()
      },
    },

  methods: {
    fetchUtils () {
      this.$store.dispatch("fetchCountries");
      this.$store.dispatch("fetchDepartments");
    },

    editItem (item) {
      this.editedIndex = this.departements.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem (item) {
      this.del_index = this.departements.indexOf(item);
      this.dialog_deletion = true;
      this.del_department = item;
    },

    close () {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateDepartment", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Département édité avec succès !";
      }
      else {
        await this.$store.dispatch("createDepartment", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Département enregistré avec succès !";
      }
      this.close();
    },


    async delDepartment(){
      await this.$store.dispatch("deleteDepartment", this.del_department);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Département supprimé avec succès !";
    },

  }
};
</script>

<style scoped>
.white-couleur{
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/department.vue